import '../../common_screen/home_tab/index.css';
import React, { useState } from 'react';
import useGame from '../../../utilities/hooks/game';
import { useLink } from 'react-router-stack';
import { isSmartPhone } from '../../../utilities/helper';
import { useSelector } from 'react-redux';
import HomeTabWeb from './index_web';
import HomeTabMWeb from './index_mweb';

const HomeTab = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useLink();
  const [routes] = useState([
    { key: 'Leagues', title: 'Leagues' },
    { key: 'MyContests', title: 'My Contests' },
    { key: 'MyAnswers', title: 'My Answers' }
  ]);
  const { myAnswersList, myContestList } = useSelector((state: any) => state.fantasy_yes_no);
  const { item: matchItem, gameType } = useGame();
  const onCalledDeadline = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onChangeIndex = (activeTab = 0) => {
    setActiveTab(activeTab);
  };

  const onChangeTab = (_event: React.SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };
  const totalTeamsCount = myAnswersList[matchItem._id]?.length || 0;
  return (
    <>
      {!isSmartPhone ? (
        <HomeTabWeb
          activeTab={activeTab}
          routes={routes}
          myAnswersList={myAnswersList}
          myContestList={myContestList}
          matchItem={matchItem}
          gameType={gameType}
          onCalledDeadline={onCalledDeadline}
          onPressBack={onPressBack}
          onChangeIndex={onChangeIndex}
          onChangeTab={onChangeTab}
          totalTeamsCount={totalTeamsCount}
        />
      ) : (
        <HomeTabMWeb
          activeTab={activeTab}
          routes={routes}
          myAnswersList={myAnswersList}
          myContestList={myContestList}
          matchItem={matchItem}
          gameType={gameType}
          onCalledDeadline={onCalledDeadline}
          onPressBack={onPressBack}
          onChangeIndex={onChangeIndex}
          onChangeTab={onChangeTab}
          totalTeamsCount={totalTeamsCount}
        />
      )}
    </>
  );
};

export default HomeTab;
